// Customer type options by CountryCode

export var CustomerTypeConfigurations = (function() {
    var getCustomerConfigs = function(countryCode, USER_TYPE, strings) {
        switch (countryCode) {
        case 'US':
            var multiDisplay = true;
            var getCustomerTypes = [];
            var retailCustomer = {
                type: USER_TYPE.RETAIL_CUSTOMER,
                label: strings.get('tdc_customerButton'),
                description: strings.get('tdc_customerDescription'),
                queryParameter: USER_TYPE.RETAIL_CUSTOMER
            };

            var preferredCustomer = {
                type: USER_TYPE.PREFERRED_CUSTOMER,
                label: strings.get('tdc_memberButton'),
                description: strings.get('tdc_memberDescription'),
                queryParameter: USER_TYPE.PREFERRED_CUSTOMER
            };
            getCustomerTypes.push(retailCustomer, preferredCustomer);
            return {
                multiDisplay: multiDisplay,
                getCustomerTypes: getCustomerTypes
            };
        case 'TH':
            var multiDisplay = false;
            var getCustomerTypes = [];
            var retailCustomer = {
                type: USER_TYPE.RETAIL_CUSTOMER,
                label: strings.get('tdc_customerButton'),
                description: strings.get('tdc_customerDescription'),
                queryParameter: USER_TYPE.RETAIL_CUSTOMER
            };
            getCustomerTypes.push(retailCustomer);
            return {
                multiDisplay: multiDisplay,
                getCustomerTypes: getCustomerTypes
            };
        default:
            var multiDisplay = true;
            var getCustomerTypes = [];
            var retailCustomer = {
                type: USER_TYPE.RETAIL_CUSTOMER,
                label: strings.get('tdc_customerButton'),
                description: strings.get('tdc_customerDescription'),
                queryParameter: USER_TYPE.RETAIL_CUSTOMER
            };
            var preferredCustomer = {
                type: USER_TYPE.PREFERRED_CUSTOMER,
                label: strings.get('tdc_memberButton'),
                description: strings.get('tdc_memberDescription'),
                queryParameter: USER_TYPE.PREFERRED_CUSTOMER
            };
            getCustomerTypes.push(retailCustomer, preferredCustomer);
            return {
                multiDisplay: multiDisplay,
                getCustomerTypes: getCustomerTypes
            };
        }
    };
    return {
        getCustomerConfigs: getCustomerConfigs
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/customer-types/customer-type-configurations.js
// module id = 346
// module chunks = 0